import React from 'react';
import styled from 'styled-components';
import { Form } from 'antd';
import PropTypes from 'prop-types';

const NewItem = styled(Form.Item)`
  margin-bottom: 0 !important;
  label {
    color: rgba(100,116,124,0.85) !important;
    font-weight: 400 !important;
    font-size: 13px !important;
  }

  ${p => p.height && `
  .ant-form-item-control {
    height: ${p.height}px;
  }
  `}
`;

const FormField = ({ height = '60px', ...rest }) => <NewItem height={height} {...rest} />;

FormField.propTypes = {
  height: PropTypes.string,
};

export default FormField;
